import { RootState } from 'store/configureStore';

export const fundingLoansListSelector = (store: RootState) =>
  store.funding.loansList;
export const fundingLoansCountSelector = (store: RootState) =>
  store.funding.loansCount;
export const fundingCRFLoansListSelector = (store: RootState) =>
  store.funding.crfLoansList;
export const fundingCRFLoansCountSelector = (store: RootState) =>
  store.funding.crfLoansCount;
export const fundingGrantsListSelector = (store: RootState) =>
  store.funding.grantsList;
export const fundingGrantsCountSelector = (store: RootState) =>
  store.funding.grantsCount;
export const fundingIsLoadingSelector = (store: RootState) =>
  store.funding.isLoading;
export const crfLoansIsFetcgingSelector = (store: RootState) =>
  store.funding.isCRFLoansFetching;
export const crfLoansIsConnectingToCRFProduct = (store: RootState) =>
  store.funding.isConnectingToCRFProduct;
export const crfLoansConnectedCRFProductSelector = (store: RootState) =>
  store.funding.connectedCRFProduct;

export const connectToCRFProductErrorSelector = (store: RootState) =>
  store.funding.isConnectToCRFProductError;

export const fundingAvailableProductTypesSelector = (state: RootState) =>
  state.funding.availableProductTypes;
export const fundingLoanFilterDetailsSelector = (store: RootState) =>
  store.funding.loanFilterDetails;
export const fundingIsLoanFilterDetailsLoadingSelector = (store: RootState) =>
  store.funding.isLoanFilterDetailsLoading;

export const fundingLoanFilterEnabledSelector = (state: RootState) =>
  state.funding.loanFilterDetails?.isEnabled;

export const fundingGrantFilterDetailsSelector = (store: RootState) =>
  store.funding.grantFilterDetails;
export const fundingIsGrantFilterDetailsLoadingSelector = (store: RootState) =>
  store.funding.isGrantFilterDetailsLoading;

export const fundingGrantFilterEnabledSelector = (state: RootState) =>
  state.funding.grantFilterDetails?.isEnabled;

export const fundingTopMatchLoansListSelector = (store: RootState) =>
  store.funding.topMatch.loansList;

export const fundingTopMatchLoanIsLoadingSelector = (store: RootState) =>
  store.funding.topMatch.isLoading;

export const fundingTopMatchGrantsListSelector = (store: RootState) =>
  store.funding.topMatch.grantsList;

export const fundingTopMatchGrantIsLoadingSelector = (store: RootState) =>
  store.funding.topMatch.isLoading;
